import React, { useCallback, useEffect, useState } from "react";
import { createPortal } from "react-dom";
import cn from "classnames";
import { disableBodyScroll, clearAllBodyScrollLocks } from "body-scroll-lock";
import styles from "./ModalTutor.module.sass";
import Icon from "../Icon";
import Card from "../Card";
import TextInput from "../TextInput";

const ModalPromotion = ({ visible, onClose, onSave, promotion, formation }) => {
    const [formData, setFormData] = useState({
        title_promotion: '',
        training_start_date: '',
        training_end_date: '',
    });

    useEffect(() => {
        if (visible) {
            const target = document.querySelector("#modal-promotion");
            if (target) {
                disableBodyScroll(target);
            }
            if (promotion) {
                // Format dates for the input fields (YYYY-MM-DD)
                const startDate = promotion.training_start_date ? new Date(promotion.training_start_date).toISOString().split('T')[0] : '';
                const endDate = promotion.training_end_date ? new Date(promotion.training_end_date).toISOString().split('T')[0] : '';
                
                setFormData({
                    title_promotion: promotion.title_promotion || '',
                    training_start_date: startDate,
                    training_end_date: endDate,
                });
            } else {
                // Reset form for new promotion
                setFormData({
                    title_promotion: '',
                    training_start_date: '',
                    training_end_date: '',
                });
            }
        } else {
            clearAllBodyScrollLocks();
        }
    }, [visible, promotion]);

    const escFunction = useCallback((e) => {
        if (e.keyCode === 27) {
            onClose();
        }
    }, [onClose]);

    useEffect(() => {
        document.addEventListener("keydown", escFunction, false);
        return () => {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [escFunction]);

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSwitchChange = (name, value) => {
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        const dataToSave = {
            ...formData,
            formations_id: formation?.id,
            // Convertir les dates en format ISO
            training_start_date: formData.training_start_date ? new Date(formData.training_start_date).toISOString() : null,
            training_end_date: formData.training_end_date ? new Date(formData.training_end_date).toISOString() : null,
        };
        onSave(dataToSave);
    };

    return createPortal(
        visible && (
            <div id="modal-promotion" className={styles.modal}>
                <div className={styles.control}>
                    <button className={styles.close} onClick={onClose}>
                        <Icon name="close" size="20" />
                    </button>
                </div>
                <div className={styles.outer}>
                    <Card
                        className={styles.card}  
                        title={promotion ? 'Modifier la promotion' : 'Ajouter une promotion'}
                        classTitle="title-blue"
                    >
                        <div className={styles.description}>
                            <div>
                                <form style={{ marginBottom: '20px', fontSize: '16px' }} onSubmit={handleSubmit}>

                                <TextInput
                                            className={styles.field}
                                            label="Titre de la promotion"
                                            name="title_promotion"
                                            value={formData.title_promotion}
                                            onChange={handleChange}
                                            required
                                        />
                                    <div className={styles.group}>
                                        <TextInput
                                            className={styles.field}
                                            label="Date de début"
                                            name="training_start_date"
                                            type="date"
                                            value={formData.training_start_date}
                                            onChange={handleChange}
                                        />
                                        <TextInput
                                            className={styles.field}
                                            label="Date de fin"
                                            name="training_end_date"
                                            type="date"
                                            value={formData.training_end_date}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    <div className={styles.divider} />

                                    <div className={styles.actions} style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                                        <button type="button" className="button-stroke" onClick={onClose}>Annuler</button>
                                        <button type="submit" className="button">Enregistrer</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </Card>
                </div>
            </div>
        ),
        document.body
    );
};

export default ModalPromotion;